let ClientQuicksightURL = () => {
    let client = localStorage.getItem('customerNo');

    switch (client) {
        case "1330":
            return {
                "BASE_QUICKSIGHT_DASHBOARD": "90cad61a-2cb6-42f2-a890-54815fc1f63b",
                "INTERNAL_FREIGHT_MIS_REPORT":"48b2dd68-0dc4-42d7-9834-43c10c80f389"
            }
        case "1375":
            return {
                "BASE_QUICKSIGHT_DASHBOARD": "d5ab4e0a-1667-44a5-9364-9b3404c31a0f"
            }
        default:
            return {
                "BASE_QUICKSIGHT_DASHBOARD": ''
            }
    }
}

export default ClientQuicksightURL();